import {
  AuthRequestOtpBodyType,
  AuthRequestOtpResponseType
} from "@website/widget/login/services/auth-request-otp/auth-request-otp.types";
import { BASE_URL_PROFILE } from "@website/widget/login/services/urls";
import { Axios } from "@website/widget/login/utils";
import { AxiosResponse } from "axios";

export const AuthRequestOtpUrl = `${BASE_URL_PROFILE}/auth/request-otp`;
export const AuthRequestOtpByCallUrl = `${BASE_URL_PROFILE}/auth/request-audio-otp`;

export const AuthRequestOtpService = (
  body: AuthRequestOtpBodyType
): Promise<AuthRequestOtpResponseType> =>
  Axios.post(AuthRequestOtpUrl, body).then(
    ({ data }: AxiosResponse<AuthRequestOtpResponseType>) => data
  );

export const AuthRequestOtpByCallService = (
  body: AuthRequestOtpBodyType
): Promise<AuthRequestOtpResponseType> =>
  Axios.post(AuthRequestOtpByCallUrl, body).then(
    ({ data }: AxiosResponse<AuthRequestOtpResponseType>) => data
  );
